interface LogoProps {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md' | 'lg';
}

export default function Logo({ variant = 'dark', size = 'md' }: LogoProps) {
  const isLight = variant === 'light';

  const badgeSize = size === 'sm' ? 'w-8 h-8 text-xs' : size === 'lg' ? 'w-14 h-14 text-xl' : 'w-10 h-10 text-sm';
  const titleSize = size === 'sm' ? 'text-sm' : size === 'lg' ? 'text-2xl' : 'text-base';
  const subtitleSize = size === 'sm' ? 'text-[9px]' : size === 'lg' ? 'text-sm' : 'text-[10px]';

  return (
    <div className="flex items-center gap-3 select-none">
      {/* Badge mark */}
      <div
        className={`${badgeSize} flex items-center justify-center rounded-md font-black tracking-tight flex-shrink-0 ${
          isLight ? 'bg-white text-texas-red' : 'bg-texas-red text-white'
        }`}
        style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-0.03em' }}
      >
        TC
        <span className={isLight ? 'text-texas-red/50' : 'text-white/60'}>SA</span>
      </div>

      {/* Wordmark */}
      <div className="flex flex-col leading-none">
        <span
          className={`${titleSize} font-bold tracking-tight whitespace-nowrap ${
            isLight ? 'text-white' : 'text-texas-navy'
          }`}
          style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-0.02em' }}
        >
          Texas <span className={isLight ? 'text-white/70' : 'text-texas-red'}>CSA</span>
        </span>
        <span
          className={`${subtitleSize} font-medium tracking-widest uppercase mt-0.5 whitespace-nowrap ${
            isLight ? 'text-white/55' : 'text-texas-navy/50'
          }`}
        >
          Consultancy &amp; Sales Agency
        </span>
      </div>
    </div>
  );
}
